import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-base-layer',
  templateUrl: './base-layer.component.html',
  styleUrls: ['./base-layer.component.scss']
})
export class BaseLayerComponent implements OnInit {

  @Input() map: any;
  @Input() layersList: any;

  constructor() { }

  ngOnInit() {
    for (const key in this.layersList.baseLayers) {
      if (key) {
        const val = this.layersList.baseLayers[key];
        if (this.map.hasLayer(val)) {
          this.layersList.baseLayers[key].options.class = 'card card-maps h-100 active';
        } else {
          this.layersList.baseLayers[key].options.class = 'card card-maps h-100';
        }
      }
    }
  }

  showAndHideLayer(layer, base) {
    if (base) {
      for (const key in this.layersList.baseLayers) {
        if (this.layersList.baseLayers.hasOwnProperty(key)) {
          const value = this.layersList.baseLayers[key];
          if (this.map.hasLayer(value)) {
            this.map.removeLayer(value);
            this.layersList.baseLayers[key].options.visible = false;
            this.layersList.baseLayers[key].options.class = 'card card-maps h-100';
          }
        }
      }
      this.map.addLayer(layer);
      layer.options.visible = true;
      layer.options.class = 'card card-maps h-100 active';
      return;
    }
  }

}
